import styled from "@emotion/styled";
import { theme } from "@repo-sapiens/theme";
import React from "react";
import Select from "react-dropdown-select";

//const Styled = ({ options, title }) => (
//  <React.Fragment>
//    <Heading
//      title={title}
//      source="https://github.com/sanusart/react-dropdown-select/tree/master/docs/src/examples/Styled.js"
//    />
//
//    <StyledSelect
//      multi
//      options={options}
//      values={[options[0]]}
//      color="#333"
//      dropdownGap={0}
//      onChange={(value) =>
//        console.log(`%c > onChange ${title} `, 'background: #555; color: tomato', value)
//      }
//    />
//  </React.Fragment>
//);

const StyledSelect = styled(Select)`
  background: ${theme.colors.background.secondary} !important;
  border: 1px solid ${theme.colors.border.primary} !important;
  color: ${theme.colors.text.primary} !important;
  width: 312px !important;
  border-radius: 8px !important;
  height: 40px !important;
  font-size: 14px !important;

  .react-dropdown-select-clear,
  .react-dropdown-select-dropdown-handle {
    color: ${theme.colors.text.primary} !important;
    font-size: 12px !important;
  }

  .react-dropdown-select-option {
    border: 1px solid red;
  }

  .react-dropdown-select-item {
    color: ${theme.colors.text.seconday};
    font-size: 12px !important;
  }

  .react-dropdown-select-input {
    color: ${theme.colors.text.primary};
    font-size: 12px !important;
  }

  .react-dropdown-select-dropdown {
    position: absolute;
    left: 0;
    border: 1px solid ${theme.colors.border.primary} !important;
    width: 500px;
    padding: 0;
    display: flex;
    flex-direction: column;
    border-radius: 2px;
    max-height: 300px;
    overflow: auto;
    z-index: 9;
    background: ${theme.colors.background.secondary};
    box-shadow: none;
    color: #fff !important;
    font-size: 12px !important;
  }

  .react-dropdown-select-item {
    color: ${theme.colors.text.seconday} !important;
    border-bottom: 1px solid #333;

    :hover {
      color: #ffffff80;
      background: ${theme.colors.text["highlight/1"]};
    }
  }

  .react-dropdown-select-item.react-dropdown-select-item-selected,
  .react-dropdown-select-item.react-dropdown-select-item-active {
    //background: #111;
    border-bottom: 1px solid #333;
    color: #fff;
    font-weight: bold;
  }

  .react-dropdown-select-item.react-dropdown-select-item-disabled {
    background: #777;
    color: #ccc;
  }
`;

type Props = {
  options: { value: string; label: string }[];
  defaultValue?: { value: string; label: string };
  onChange?: (value: string) => void;
};
export const ReactWithSeach: React.FC<Props> = ({
  options,
  defaultValue,
  onChange,
}) => (
  <StyledSelect
    values={defaultValue ? [defaultValue] : []}
    searchable
    options={options}
    onChange={(values) => onChange?.((values[0] as unknown as { value: string })?.value ?? "")}
  />
);
